import { api } from 'http/helpers';
import URLS from 'http/urls';
import http from 'http/http';
import { PageableListRequestParams, PageableListResponse } from 'http/types';
import {
  Email,
  EmailSendDto,
  EmailShort,
  EmailUserGroupsResponse,
} from './types';

export const emailApi = {
  fetchEmailAll(params: PageableListRequestParams) {
    return http.get<PageableListResponse<EmailShort>>(api(URLS.email.all), {
      params,
    });
  },

  fetchEmailById(id: string) {
    return http.get<Email>(api(URLS.email.item), {
      replacePathParams: { id },
    });
  },

  fetchUserGroups() {
    return http.get<EmailUserGroupsResponse>(api(URLS.email.userGroups));
  },

  fetchEmailFooter() {
    return http.get<string>(api(URLS.email.footer));
  },

  sendEmail(email: EmailSendDto) {
    return http.post(api(URLS.email.send), email);
  },
};
